import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-photo-taker-button flex-center" }
const _hoisted_2 = ["src"]

import { namedImages, useLayoutStore } from '@/store'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'SnapshotButton',
  emits: ['show-mask'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const layoutStore = useLayoutStore()
const { drawerStateClassName, snapshotButtonVisibility } =
  storeToRefs(layoutStore)

const computedOpacity = computed(() => {
  const o = (layoutStore.drawerState?.progress || 0) * 3
  return o < 0 ? 1 : o > 1 ? 0 : 1 - o
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'c-photo-taker',
      'flex-center',
      _unref(snapshotButtonVisibility),
      _unref(drawerStateClassName)
    ]),
    style: _normalizeStyle({ '--computed-opacity': computedOpacity.value }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('show-mask')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "c-photo-taker-icon",
        src: _unref(namedImages).icon_camera
      }, null, 8, _hoisted_2)
    ])
  ], 6))
}
}

})